import request from '@/utils/request'

const url = 'admin/user_member_cancel'

export function submitMemberCancel(data) {
  return request({
    url: `${url}/submit`,
    method: 'post',
    data
  })
}

export function listMemberCancel(data) {
  return request({
    url: `${url}/list`,
    method: 'post',
    data
  })
}

export function detailMemberCancel(data) {
  return request({
    url: `${url}/detail`,
    method: 'post',
    data
  })
}

export function level1ApproveMemberCancel(data) {
  return request({
    url: `${url}/level1Approve`,
    method: 'post',
    data
  })
}

export function level2ApproveMemberCancel(data) {
  return request({
    url: `${url}/level2Approve`,
    method: 'post',
    data
  })
}

export function deleteRejectedMemberCancel(data) {
  return request({
    url: `${url}/deleteRejected`,
    method: 'post',
    data
  })
}
